<template>
    <transition name="fade">
        <div class="fixed right-0 bottom-0" v-show="scY > 10" @click="toTop">
            <IconComponent icon="top-arrow" class="material-icons" />
        </div>
    </transition>
</template>
<script>
import IconComponent from '@/assets/images/IconComponent.vue'

export default {
    components: {
        IconComponent,
    },
    data() {
        return {
            scTimer: 0,
            scY: 0,
        }
    },
    methods: {
        handleScroll() {
            if (this.scTimer) return
            this.scTimer = setTimeout(() => {
                this.scY = window.scrollY
                clearTimeout(this.scTimer)
                this.scTimer = 0
            }, 10)
        },
        toTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            })
        },
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },

}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/colors";

.fade-enter-active,
.fade-leave-active {
    transition: opacity .1s ease-out;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.fixed {
    .material-icons {
        width: 50px;
        fill: white;
        background: $color-betano;
        border-radius: 50%;
        cursor: pointer;
    }

    @media only screen and (max-width: 580px) {
        .material-icons {
            width: 30px;
        }
    }
}
</style>
